import { UPLOAD_FILE } from 'constants';
import { call, takeLatest } from 'redux-saga/effects';
import { makeAttach } from './attachUtils';

/**
 * Загрузить файл
 * @param payload
 * @returns {IterableIterator<*>}
 */
function* upload({ payload }) {
  const { files, callback } = payload;
  // создание аттачей
  const attachments = yield call(makeAttach, files);
  const uploadedFiles = attachments.filter((f) => !!f.fileName);
  if (callback) callback(uploadedFiles);
}

function* uploadFile() {
  yield takeLatest(UPLOAD_FILE.REQUEST, upload);
}

export default uploadFile;
